import { useState, useEffect, useLayoutEffect } from 'react';

const TABLET_MIN_WIDTH = 767;
const DESKTOP_MIN_WIDTH = 1023;

export function useScreenDetector() {
    const [width, setWidth] = useState(0);

    const canUseDOM = typeof window !== 'undefined';
    const useEffectHook = canUseDOM ? useLayoutEffect : useEffect;

    const handleResize = () => {
        setWidth(window.innerWidth);
    };

    useEffectHook(() => {
        handleResize();

        window.addEventListener('resize', handleResize);

        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const isMobile = width <= TABLET_MIN_WIDTH;
    const isTablet = width <= DESKTOP_MIN_WIDTH;
    const isDesktop = width > DESKTOP_MIN_WIDTH;

    return { isMobile, isTablet, isDesktop };
}
